import React, { useEffect, useState } from "react";
import Navbar from "../component/layout/navbar";
import Footer from "../component/layout/footer";
import ViewConfig from "../config/viewConfig";
import AOS from 'aos';
import 'aos/dist/aos.css';
import { useLocation } from "react-router-dom";
import { useDrawerTransition } from "../context/drawerProvider";

const PortalLayout = ({ children }) => {
  const mobileView = ViewConfig();
  const location = useLocation();
  const { isAnimating } = useDrawerTransition();
  const [fadeIn, setFadeIn] = useState(false);

  useEffect(() => {
    AOS.init({ duration: 1000, once: true, offset: 100 });
  }, []);

  useEffect(() => {
    AOS.refresh();

    // Reset fade-in
    setFadeIn(false);

    // Wait for drawer to finish before fading in content
    let timeout;
    if (!isAnimating) {
      timeout = setTimeout(() => {
        setFadeIn(true);
      }, 100); // small delay after drawer finishes
    }

    return () => clearTimeout(timeout);
  }, [location, isAnimating]);



  return (
    <div className="relative flex min-h-screen flex-col bg-[#F1F5F9]">
     {!location.pathname.includes('assessment') && <Navbar mobileView={mobileView} />}

      {/* Content wrapper with fade-in */}
      <div
        className={(location.pathname.includes('login') || location.pathname.includes('assessment') ? '' : 'pt-16 ') + `flex-1 transition-opacity duration-600 ease-in ${fadeIn ? "opacity-100" : "opacity-0"
          }`}
      >
        {children}
      </div>

      {!location.pathname.includes('login') && !location.pathname.includes('assessment') && <Footer />}
    </div>
  );
};

export default PortalLayout;
